
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import Diagnose from '@/types/Diagnose';
    import Diagnosenbezeichnung from '@/types/Diagnosenbezeichnung';
    import { ValidationRules } from '@/store/types';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
        },
    })
    export default class DiagnosenDiagnosenbezeichnungen extends Vue {
        @Prop() diagnosenbezeichnungen!: Diagnosenbezeichnung[];
        @Prop() loading!: boolean;
        @Prop() disabled!: boolean;
        @Prop() diagnosenbezeichnungsnrError!: boolean;
        @Prop() diagnose!: Diagnose;

        public $refs!: {
            diagnosenbezeichnungen: Vue;
            text: Vue;
        };

        public rules!: ValidationRules[];
        public changeddiagnosenbezeichnungen = new Diagnosenbezeichnung();

        public get diagnosenbezeichnungClass(): string {
            return this.diagnosenbezeichnungsnrError ? ' error--text' : '';
        }

        public get tableHeight(): string | undefined {
            const count = this.diagnosenbezeichnungen?.length;
            return count > 10 ? '400px' : undefined;
        }

        public onClickAdd(): void {
            this.diagnosenbezeichnungen.push(new Diagnosenbezeichnung());

            this.$nextTick(() => {
                const table = this.$refs.diagnosenbezeichnungen.$el.firstElementChild;
                if (table) {
                    table.scrollTop = table.scrollHeight;
                }
            });
        }

        public onClickDeleteAll(): void {
            this.diagnosenbezeichnungen.splice(0, this.diagnosenbezeichnungen.length);
        }

        public onClickDelete(diagnosenbezeichnung: Diagnosenbezeichnung): void {
            const index = this.diagnosenbezeichnungen.indexOf(diagnosenbezeichnung);
            this.diagnosenbezeichnungen.splice(index, 1);
        }

        public onClickCopy(diagnosenbezeichnung: Diagnosenbezeichnung): void {
            const copy = Object.assign(new Diagnosenbezeichnung(), {
                ...diagnosenbezeichnung,
                diagnosenbezeichnung_id: null,
                isPersistent: undefined,
            });

            this.diagnosenbezeichnungen.push(copy);
        }

        public get textLabelClass(): string {
            return this.diagnosenbezeichnungClass === ''
                ? 'primary--text'
                : 'red--text';
        }

        public ellipsis(html: string): string {
            const div = document.createElement('div');
            div.innerHTML = html;

            const stripped = div.textContent ?? div.innerText ?? '';
            const maxLength = 15;

            return stripped.length > maxLength
                ? (stripped.substr(0, maxLength) + '...')
                : stripped;
        }

        @Watch('diagnosenbezeichnungen')
        public changeDiagnosenbezeichnungen() {
            this.diagnose.diagnosenbezeichnungen = this.diagnosenbezeichnungen;
        }
    }
